import { RESET_STATE, UPDATE_PREVIEW_ITEMS, SET_RESULTS_FOR_QUERY_ID } from './constants';

export const initialState = {
  previewItems: [],
  resultsMap: {}, // [queryId]: results
};

// eslint-disable-next-line default-param-last
export default function reducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case RESET_STATE: {
      return initialState;
    }
    case UPDATE_PREVIEW_ITEMS: {
      return {
        ...state,
        previewItems: payload,
      };
    }
    case SET_RESULTS_FOR_QUERY_ID: {
      const { resultsMap } = state;
      const { queryId, results } = payload;

      return {
        ...state,
        resultsMap: {
          ...resultsMap,
          [queryId]: results,
        },
      };
    }
    default:
      return state;
  }
}
